jQuery( document ).ready( function ( $ ) {

  var module_name = 'pros_cons';

} );